import { TextField } from '@ff-it/form';
import { OOHCategoryFormatField } from './OOHCategoryFormatField';
import { required } from 'utilities';
import { OOHFormatForm } from './OOHFormatForm';

export function OOHConfigForm() {
  return (
    <>
      <div className="form-row">
        <OOHCategoryFormatField
          name="configuration.category_format"
          label="Category"
          className="col-md-5"
          required
          validate={required}
        />
        <TextField
          name="configuration.code_or_number"
          label="Code or number"
          className="col-md-2"
          help="Vendor product code or number"
        />
      </div>
      <div className="col-md-10 px-0">
        <OOHFormatForm name="configuration.format." />
      </div>
    </>
  );
}
